import { createSelector, defaultMemoize, createSelectorCreator } from 'reselect';
import { selectors } from 'redux-clerk2';
import isEqual from 'lodash.isequal';
import { Map, List } from 'immutable';

const createDeepEqualSelector = createSelectorCreator(
	defaultMemoize,
	isEqual
);

const notifsSelectors = selectors({
	baseSelector: state => state.notifs
});

export const base = selectors({
baseSelector: state => state.notifs
});

export default notifsSelectors;

const defaultList = List();
const fetchDatasetData = (state, instance) => {
	const data = base.dataset(state, instance).get('data', defaultList);
	return data;
}

export const fetchDataset = createDeepEqualSelector(
	[ fetchDatasetData ],
	(data) => data.toJSON()
);

const fetchPropertyData = (state, instance, property) => state.notifs.getIn(['instances', instance, 'additionalData', property]);
export const fetchProperty = createSelector(
	[ fetchPropertyData ],
	(data) => {
		if(Map.isMap(data) || List.isList(data)){
			return data.toJSON();
		}
		return data
	}
);

const fetchRecordData = (state, id) => (id !== undefined)?base.record(state, id):Map();
export const fetchRecord = createSelector(
	[ fetchRecordData ],
	(data) => data && data.toJSON()
);